module.exports = "<p>\r\n  about works!\r\n</p>\r\n"